import { BookIcon, DatabaseZapIcon, FileArchiveIcon, FileLock2Icon, GlobeLockIcon, KeyIcon, MailIcon, MinimizeIcon, UsersIcon, ZapIcon } from 'lucide-react';

import AppSidebar from '@Components/app-layout/Sidebar';
import { useGlobalAuthStore } from '@Stores/global/auth';
import AppSidebarItem from 'components/app-layout/SidebarItem';

export default function SettingSidebar() {
  const { auth: { isManagerAdmin, isSuperAdmin } } = useGlobalAuthStore()
  return <AppSidebar>
    <AppSidebarItem
      to='/settings/integrations'
      icon={MinimizeIcon}
      alias='Integrations'
    />
    <AppSidebarItem
      to='/settings/blacklist'
      icon={FileLock2Icon}
      alias='User Blacklist'
    />
    <AppSidebarItem
      to='/settings/ip-blacklist'
      icon={GlobeLockIcon}
      alias='IP Blacklist'
    />
    <AppSidebarItem
      to='/settings/email-templates'
      icon={MailIcon}
      alias='Email Templates'
    />
    <AppSidebarItem
      to='/settings/datasources'
      icon={DatabaseZapIcon}
      alias='Datasources'
    />
    <AppSidebarItem
      to='/settings/validators'
      icon={ZapIcon}
      alias='Validators'
    />
    <AppSidebarItem
      to='/settings/data-extractors'
      icon={FileArchiveIcon}
      alias='Data Extractors'
    />
    {(isSuperAdmin || isManagerAdmin) && <>
      <AppSidebarItem
        to="/settings/users"
        icon={UsersIcon}
        alias='Users'
      />
      <AppSidebarItem
        to="/settings/tokens"
        icon={KeyIcon}
        alias='Tokens'
      />
    </>}
    <AppSidebarItem
      to="/settings/log-viewer"
      icon={BookIcon}
      alias='Log Viewer'
    />
  </AppSidebar>
}
